// swatches

export const colors = [
	{
		color: 'black',
    name: 'Black',
    images: [
      {
        type: 'swatch',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/ss-black.jpg'
      }
    ]
	},
	{
		color: 'navy',
    name: 'Navy',
    images: [
      {
        type: 'swatch',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/ss-navy.jpg'
      }
    ]
	},
	{
		color: 'taupe',
    name: 'Taupe',
    images: [
      {
        type: 'swatch',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/ss-taupe.jpg'
      }
    ]
	},
	{
		color: 'burgundy',
    name: 'Burgundy',
    images: [
      {
        type: 'swatch',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/ss-burgundy.jpg'
      }
    ]
	},
	{
		color: 'brown',
    name: 'Brown',
    images: [
      {
        type: 'swatch',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/ss-brown.jpg'
      }
    ]
	},
	{
		color: 'creme',
    name: 'Creme',
    images: [
      {
        type: 'swatch',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/ss-creme.jpg'
      }
    ]
	},
	{
		color: 'natural',
    name: 'Natural',
    images: [
      {
        type: 'swatch',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/ss-natural.jpg'
      }
    ]
	},
	{
		color: 'silver',
    name: 'Silver',
    images: [
      {
        type: 'swatch',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/ss-silver.jpg'
      }
    ]
	},
	{
		color: 'oyster',
    name: 'Oyster',
    images: [
      {
        type: 'swatch',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/ss-oyster.jpg'
      }
    ]
	},
	{
		color: 'oak',
    name: 'Oak',
    images: [
      {
        type: 'swatch',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/ss-oak.jpg'
      }
    ]
	},
	{
		color: 'charcoal',
    name: 'Charcoal',
    images: [
      {
        type: 'swatch',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/ss-charcoal.jpg'
      }
    ]
	},
	{
		color: 'slate',
    name: 'Slate',
    images: [
      {
        type: 'swatch',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/ss-slate.jpg'
      }
    ]
	},
	{
		color: 'beige',
    name: 'Beige',
    images: [
      {
        type: 'swatch',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/ss-beige.jpg'
      }
    ]
	},
	{
		color: 'mid-gray',
    name: 'Mid Gray',
    images: [
      {
        type: 'swatch',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/ss-mid-gray.jpg'
      }
    ]
	},
	{
		color: 'honey-tan',
    name: 'Honey Tan',
    images: [
      {
        type: 'swatch',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/ss-honey-tan.jpg'
      }
    ]
	},
	{
		color: 'metallic-blue',
    name: 'Metallic Blue',
    images: [
      {
        type: 'swatch',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/ss-metallic-blue.jpg'
      }
    ]
	}
];
